<app-svg-icon>
  <svg width="26" height="16" viewBox="0 0 26 16" xmlns="http://www.w3.org/2000/svg">
    <rect width="26" height="16" rx="8"/>
    @if (checked()) {
      <circle cx="18" cy="8" r="6.5" style="fill: #fff"/>
      <path clip-rule="evenodd" d="M21.7126 5.03478C21.9695 5.2441 22.008 5.62203 21.7987 5.87892L17.7246 10.8789C17.6116 11.0177 17.4425 11.0987 17.2636 11.0999C17.0846 11.1011 16.9144 11.0224 16.7995 10.8852L14.2069 7.78984C13.9942 7.5358 14.0276 7.15738 14.2816 6.94461C14.5357 6.73183 14.9141 6.76528 15.1269 7.01932L17.2531 9.55788L20.8684 5.12092C21.0778 4.86403 21.4557 4.82546 21.7126 5.03478Z"/>
    }
    @else {
      <circle cx="8" cy="8" r="6.5" style="fill: #fff"/>
      <path d="M11.125 4.875L4.875 11.125" class="fill-stroke" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M11.125 11.125L4.875 4.875" class="fill-stroke" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
    }
  </svg>
</app-svg-icon>
